import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: 'Montserrat', sans-serif;
  }

  html {
    scroll-behavior: smooth;
    -webkit-text-size-adjust: 100%;
    text-size-adjust: 100%;
  }

  html, body {
    overflow-x: hidden;
    max-width: 100%;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  section[id] {
    scroll-margin-top: 80px;
  }
`;

export default GlobalStyle;
